<template>
  <v-app>

    <v-navigation-drawer v-model="$store.state.drawer" color="black" app left dark >
      <v-list nav class="py-0" >
        <v-list-item two-line>
          <v-list-item-avatar>
            <img src="https://randomuser.me/api/portraits/men/81.jpg">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Application</v-list-item-title>
            <v-list-item-subtitle>Subtext</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item  link v-for="menu in menus" :key="menu.id" :to="menu.path">
          <v-list-item-icon>
            <v-icon>{{ menu.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ menu.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>


    <v-main>
      <router-view />
    </v-main>

    <v-snackbar v-model="$store.state.snackbar.value" :timeout="1500">
      {{ $store.state.snackbar.text }}
    </v-snackbar>

  </v-app>
</template>

<script>


export default {
  name: 'App',

  data: () => ({
    letSearch: false,
    menus: [
      { id:1, icon: 'mdi-account', text: 'Customer', path: "/users" },
      { id:2, icon: 'mdi-account', text: 'Product', path: "/products" },
      { id:3, icon: 'mdi-account', text: 'Order', path: "/orders" },
      { id:4, icon: 'mdi-account', text: 'Report', path: "/reports" }
    ]
  }),
};
</script>

<style>
  .swal2-container {
    font-family: 'Roboto';
  }
</style>
